import api from "../../Hooks/axiosApi";

export const getClientListService = () => {
    const response = api.get(`/api/Crm/GetClients`);
    return response;
};
export const deleteClientService = (id: any) => {
    return api.delete(`/api/Crm/DeleteClient/${id}`);
};

export const getClientAuthTokenService = (leadId: any) => {
    return api.get(`/api/Crm/GetClientMasterLoginById?clientId=${leadId}`);
};